<div class="progress-cont">
  <div class="progress progress-bar" [ngClass]="{'bg-error': onError}" [style.width]="progress + '%'">
  </div>
</div>